import * as React from 'react';

import { translate } from '~l10n/client';
import { useDispatch, useSelector } from 'react-redux';

import { SmallButton } from '~shared/components/buttons';
import { ShareQuizDialog } from '~teacher/components/ShareQuizDialog/ShareQuizDialog';
import { selectEditingQuiz } from '~teacher/slices/quiz/quizSelectors';
import { toggleQuizSharing } from '~teacher/slices/quiz/quizSlice';

export function ShareQuiz({
  isControlsDisabled,
}: {
  isControlsDisabled: boolean;
}) {
  const dispatch = useDispatch();

  const handleEnableSharing = React.useCallback(() => {
    dispatch(toggleQuizSharing());
  }, [dispatch]);

  const [isSharingDialogOpen, setIsSharingDialogOpen] = React.useState(false);

  const { socNumber, isSharingEnabled } = useSelector(selectEditingQuiz);

  return (
    <>
      <SmallButton
        onClick={() => setIsSharingDialogOpen(true)}
        appearance="default"
      >
        {translate('Share')}
      </SmallButton>
      <ShareQuizDialog
        isOpen={isSharingDialogOpen}
        title={`${translate('Share Quiz')}`}
        isSharingEnabled={isSharingEnabled}
        socNumber={socNumber}
        handleEnableSharing={handleEnableSharing}
        isControlsDisabled={isControlsDisabled}
        closeDialog={() => setIsSharingDialogOpen(false)}
      />
    </>
  );
}
